import React, { useState, useEffect } from 'react'
import Icons from '../../Constants/Icons'
import { CustomUploadProfilePic } from '../../Core/CustomUploadProfilePic'
import { useDispatch } from 'react-redux'
import {
  setLoadingFalse,
  setLoadingTrue
} from '../../Config/Actions/loadingActions'
import {
  apiCallCreateInterestCategory,
  apiCallEditInterestCategory
} from '../../Core/Apicall'

function Modal({ show, handleClose, pageRefresh, editData }) {
  const [newCategoryName, setNewCategoryName] = useState('')
  const [imagePreview, setImagePreview] = useState('')
  const [uploadImage, setUploadImage] = useState(true)
  const [nameError, setNameError] = useState('');
  const [imageError, setImageError] = useState('');
  const dispatch = useDispatch()
  useEffect(() => {
    if (editData != undefined) {
      setImagePreview(editData?.categoryIconURL)
      setNewCategoryName(editData?.categoryName)
      setUploadImage(false)
    }
  }, [editData])

  const uploadImageRemove = () => {
    setImagePreview('')
    setUploadImage(true)
  }

  const handleImageUpload = async event => {
    dispatch(setLoadingTrue())
    const selectedImage = event.target.files[0]

    if (!selectedImage) {
      dispatch(setLoadingFalse());
      return;
    }


    const formData = new FormData()

    formData.append('imageURL', selectedImage)
    formData.append('imageType', 'IntrestCategoryImages')
    formData.append('imageStoreId', '123456789')

    try {
      const data = await CustomUploadProfilePic(formData)
      setImagePreview(data.location)
      setUploadImage(false)
       setImageError(''); // <-- ADD THIS
      dispatch(setLoadingFalse())
    } catch (error) {
      dispatch(setLoadingFalse())
    }
  }

  const handleSubmit = async () => {
    if (!newCategoryName.trim()) {
      setNameError('Category name is required');
      return;
    }
    if (imagePreview === '') {
      setImageError('Category image is required');
      return;
    }
    dispatch(setLoadingTrue())
    let param = {
      categoryName: newCategoryName,
      categoryIconURL: imagePreview
    }

    if (editData) {
      param = {
        ...param,
        categoryId: editData.categoryId
      }
    }
    try {
      if (editData) {
        await apiCallEditInterestCategory(param)
      } else {
        await apiCallCreateInterestCategory(param)
      }
      setNewCategoryName('')
      setNameError('')
      setImageError('');
      setImagePreview('')
      setUploadImage(true)
      pageRefresh()
      handleClose()
    } catch (error) {
      dispatch(setLoadingFalse())
    }
  }

  const closeModal = () => {
    setNewCategoryName('');
    setImagePreview('');
    setUploadImage(true);
    setNameError('');
    setImageError('');
    handleClose();
  }
  return (
    <div
      className={`modal-category ${show ? 'display-block' : 'display-none'}`}
      onClick={closeModal}
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        background: 'rgba(0,0,0,0.65)',
        backdropFilter: 'blur(4px)',
        display: show ? 'flex' : 'none',
        justifyContent: 'center',
        alignItems: 'center',
        zIndex: 9999
      }}
    >
      <div
        onClick={(e) => e.stopPropagation()}
        style={{
          width: '500px',
          background: '#081B3A',
          borderRadius: '20px',
          padding: '25px',
          position: 'relative',
          border: '1px solid #1f4d99',
          boxShadow: '0 10px 30px rgba(0,0,0,0.4)'
        }}
      >
        {/* Close Button */}
        <span
          onClick={closeModal}
          style={{
            position: 'absolute',
            right: '20px',
            top: '10px',
            color: '#fff',
            fontSize: '40px',
            cursor: 'pointer',
            lineHeight: 1
          }}
        >
          ×
        </span>

        {/* Title */}
        <h2
          style={{
            textAlign: 'center',
            color: '#fff',
            fontSize: '32px',
            fontWeight: '700',
            marginBottom: '8px'
          }}
        >
          {editData ? 'Edit Category' : 'Add New Category'}
        </h2>

        <p
          style={{
            textAlign: 'center',
            color: '#A9B6D3',
            fontSize: '14px',
            marginBottom: '25px'
          }}
        >
          Add a new category to organize your items
        </p>

        {/* Category Name */}
        <div style={{ marginBottom: '20px' }}>
          <label
            style={{
              display: 'block',
              color: '#fff',
              fontSize: '16px',
              fontWeight: '600',
              marginBottom: '8px'
            }}
          >
            Category Name
          </label>

          <input
            type='text'
            value={newCategoryName}
            onChange={(e) => {
              setNewCategoryName(e.target.value);

              if (e.target.value.trim()) {
                setNameError('');
              }
            }}
            placeholder='Enter Category Name'
            style={{
              width: '96%',
              height: '50px',
              borderRadius: '10px',
              border: nameError
                ? '1px solid #ff4d4f'
                : '1px solid #2d65c7',
              background: '#102B5C',
              color: '#fff',
              padding: '0 15px',
              fontSize: '15px',
              outline: 'none',
              zIndex: 10
            }}
          />
          {nameError && (
            <p
              style={{
                color: '#ff4d4f',
                fontSize: '13px',
                marginTop: '5px',
                marginBottom: 0
              }}
            >
              {nameError}
            </p>
          )}
        </div>

        {/* Upload Section */}
        <div>
          <label
            style={{
              display: 'block',
              color: '#fff',
              fontSize: '16px',
              fontWeight: '600',
              marginBottom: '10px'
            }}
          >
            Category Image
          </label>

          {uploadImage && (
            <label
              style={{
                width: '100%',
                height: '180px',
                border: '2px dashed #3B82F6',
                borderRadius: '15px',
                background: '#102B5C',
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                alignItems: 'center',
                cursor: 'pointer'
              }}
            >
              <input
                type='file'
                hidden
                accept='image/*'
                onChange={handleImageUpload}
              />

              <img
                src={Icons.upload}
                alt="upload"
                style={{
                  width: '35px',
                  marginBottom: '10px',
                  filter: 'brightness(0) invert(1)'
                }}
              />

              <h4
                style={{
                  color: '#fff',
                  margin: 0,
                  fontSize: '20px'
                }}
              >
                Upload Category Image
              </h4>

              <p
                style={{
                  color: '#A9B6D3',
                  fontSize: '13px',
                  marginTop: '5px'
                }}
              >
                Click here to upload
              </p>
            </label>
          )}


          {imagePreview && (
            <div
              style={{
                position: 'relative',
                marginTop: '10px'
              }}
            >
              <img
                src={Icons.delete}
                alt='delete'
                onClick={uploadImageRemove}
                style={{
                  position: 'absolute',
                  top: '10px',
                  right: '10px',
                  width: '35px',
                  height: '35px',
                  background: '#ff4d4f',
                  borderRadius: '50%',
                  padding: '6px',
                  cursor: 'pointer',
                  zIndex: 10
                }}
              />

              <img
                src={imagePreview}
                alt='preview'
                style={{
                  width: '100%',
                  height: '180px',
                  objectFit: 'cover',
                  borderRadius: '12px'
                }}
              />
            </div>
          )}

          {imageError && (
            <p
              style={{
                color: '#ff4d4f',
                fontSize: '13px',
                marginTop: '5px'
              }}
            >
              {imageError}
            </p>
          )}

        </div>

        {/* Save Button */}
        <div
          style={{
            display: 'flex',
            justifyContent: 'center',
            marginTop: '25px'
          }}
        >
          <button
            onClick={handleSubmit}
            style={{
              width: '180px',
              height: '48px',
              border: 'none',
              borderRadius: '10px',
              background: 'linear-gradient(90deg,#4F46E5,#3B82F6)',
              color: '#fff',
              fontSize: '16px',
              fontWeight: '600',
              cursor: 'pointer',
              transition: '0.3s'
            }}
          >
            Save Category
          </button>
        </div>
      </div>
    </div>
  )
}

export default Modal
